import React, { Component } from "react";
import Navbar from "./Navbar/Navbar";
import { Outlet } from "react-router-dom";

class MainPage extends Component {
  state = {};
  render() {
    return (
      <div className="w-full min-h-screen flex flex-col font-sans bg-white">
        <Navbar />
        
        <main className="flex-grow w-full">
          <Outlet />
        </main>
        
        <footer className="w-full border-t border-gray-200 mt-12">
          <div className="max-w-screen-2xl mx-auto py-8 text-xs text-center text-gray-500 tracking-widest uppercase">
            © {new Date().getFullYear()} Sareh Art Gallery. All rights reserved.
          </div>
        </footer>
      </div>
    );
  }
}

export default MainPage;
